module.exports = __webpack_public_path__ + "img/form-icons2.e6f1a1b5.png";